import Axios, {AxiosResponse} from "axios";
import qs from "querystring";
import RootApi from "./root-api";

export default class ParameterApi extends RootApi {
    private readonly apiEndpoint: string = `${this.ApiRoot}/parameters`;

    public async getParametersByProduct(productId: number): Promise<AxiosResponse> {
        return await Axios.get(`${this.apiEndpoint}/product/${productId}`);
    }

    public async getProductPrice(productId: number, parameterValueIds: number[]): Promise<AxiosResponse> {
        return await Axios.get(`${this.apiEndpoint}/product/${productId}/price`, {
            params: {paramValues: parameterValueIds},
            paramsSerializer: params => qs.stringify(params)
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/parameter-api.ts